import Home24 from '../components/templates/Home24';

export const config = {
  amp: false,
};

export default function IndexPage() {
  return <Home24 />;
}
